export const BLACK_BAR_COLOR = '#06162D';
export const GREEN_BAR_COLOR = '#7DBE42';
export const LIGHT_GREEN_BAR_COLOR = '#BEDEA1';
export const BLUE_COLOR = '#427EEB';
